import { render } from "./MemosPage.vue?vue&type=template&id=255009bc"
import script from "./MemosPage.vue?vue&type=script&lang=js"
export * from "./MemosPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__